import type { AllRouteEndpoints } from "../routeTypes";

export const offerfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChanges =
  "/offerfit/:app_group_id/use_cases/:use_case_id/unpromoted_customer_changes";

export const offerfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChangesCacheKeys: AllRouteEndpoints[] = [];
